<template>
	<v-card>
		<v-card-title class="px-4 py-1" v-if="customer">
			<v-col>
				<v-row>
					<h3 class="primary--text">{{ customer.name }} {{ customer.surename }}</h3>
				</v-row>
				<v-row v-if="customer.fiscal_code">
					<p class="mb-0">{{ customer.fiscal_code }}</p>
				</v-row>
			</v-col>
		</v-card-title>
		<v-divider />
		<v-card-text>
			<div v-if="!customer">
				<p class="mb-0">Seleziona un cliente dalla lista per vederne i dettagli.</p>
			</div>
			<div v-else>
				<h3 class="primary--text">Contatti</h3>
				<br />
				<table class="details">
					<tr>
						<td class="font-weight-bold">Telefono:</td>
						<td>{{ customer.phone }}</td>
					</tr>
					<tr v-if="customer.email">
						<td class="font-weight-bold">Email:</td>
						<td>{{ customer.email }}</td>
					</tr>
				</table>

				<div :key="index" v-for="(address, index) in customer.addresses">
					<br />
					<v-divider />
					<br />
					<h3 class="primary--text">Indirizzo</h3>
					<br />

					<table class="details">
						<tr>
							<td class="font-weight-bold">Indirizzo:</td>
							<td>{{ address.address }}</td>
						</tr>
						<tr>
							<td class="font-weight-bold">Città:</td>
							<td>{{ address.city }}</td>
						</tr>
						<tr>
							<td class="font-weight-bold">CAP:</td>
							<td>{{ address.cap }}</td>
						</tr>
						<tr>
							<td class="font-weight-bold">Comune:</td>
							<td>{{ address.municipality }}</td>
						</tr>
						<tr>
							<td class="font-weight-bold">Provincia:</td>
							<td>{{ address.province }} ({{ address.code }})</td>
						</tr>
						<tr>
							<td class="font-weight-bold">Regione:</td>
							<td>{{ address.region }}</td>
						</tr>
					</table>
				</div>

				<div v-if="customer.note">
					<br />
					<v-divider />
					<br />
					<h3 class="primary--text">Note</h3>
					<br />

					<p>{{ customer.note }}</p>
				</div>

				<div v-if="customer.ID_docs">
					<br />
					<v-divider />
					<br />
					<h3 class="primary--text">Documento di identità</h3>
					<br />
					<table class="details">
						<tr>
							<td class="font-weight-bold">Tipo:</td>
							<td>{{ customer.ID_docs.type }}</td>
						</tr>
						<tr>
							<td class="font-weight-bold">Numero:</td>
							<td>{{ customer.ID_docs.number }}</td>
						</tr>
						<tr>
							<td class="font-weight-bold">Nato a:</td>
							<td>{{ customer.ID_docs.birthplace }}</td>
						</tr>
						<tr>
							<td class="font-weight-bold">Data di nascita</td>
							<td>{{ customer.ID_docs.birthday.slice(0, 10) }}</td>
						</tr>
						<tr>
							<td class="font-weight-bold">Scadenza:</td>
							<td>{{ customer.ID_docs.expiration.slice(0, 10)}}</td>
						</tr>						
					</table>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'CustomerDetails',
	props: {
		customer: { type: Object, default: () => {} },
	},
	watch: {
		customer(val) {
			console.log(val)
		},
	},
}
</script>

<style scoped>
.details {
	width: 100%;
}

.details > tr > td:nth-child(1) {
	width: 30%;
}
</style>
